import React from 'react';
import { useIsAuthenticated } from 'react-auth-kit';
import { useSignOut } from 'react-auth-kit';
import { useAuthUser } from 'react-auth-kit';
import { useNavigate, Link } from 'react-router-dom';
import { Box, Button, IconButton, Typography, Drawer, List, ListItem, ListItemText, ListItemIcon, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';import PersonIcon from '@mui/icons-material/Person';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useTheme } from '@mui/material/styles';

const Navbar = () => {
    const theme = useTheme();
    const isAuthenticated = useIsAuthenticated();
    const signOut = useSignOut();
    const authUser = useAuthUser();
    const navigate = useNavigate();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [drawerOpen, setDrawerOpen] = React.useState(false);

    const handleSignOut = () => {
        signOut();
        navigate('/');
    };

    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };

    const renderLinks = () => (
        <>
            <Link to="/Infospratiques" style={{ textDecoration: 'none' }}>
                <Typography sx={{ margin: '0 15px', color: 'white', textTransform: 'uppercase', fontWeight: 'bold' }}>
                    Infos pratiques
                </Typography>
            </Link>
            <Link to="/Contact" style={{ textDecoration: 'none' }}>
                <Typography sx={{ margin: '0 15px', color: 'white', textTransform: 'uppercase', fontWeight: 'bold' }}>
                    Contact
                </Typography>
            </Link>
            {isAuthenticated() && authUser() && authUser().role === 'admin' ? (
                <Link to="/Espace_Admin" style={{ textDecoration: 'none' }}>
                    <Typography sx={{ margin: '0 15px', color: 'white', textTransform: 'uppercase', fontWeight: 'bold' }}>
                        Espace Admin
                    </Typography>
                </Link>
            ) : (
                isAuthenticated() && (
                    <Link to="/Espace_Perso" style={{ textDecoration: 'none' }}>
                        <Typography sx={{ margin: '0 15px', color: 'white', textTransform: 'uppercase', fontWeight: 'bold' }}>
                            ESPACE PERSO
                        </Typography>
                    </Link>
                )
            )}
        </>
    );

    const renderAuthButton = () => (
        isAuthenticated() ? (
            <Button
                sx={{
                    backgroundColor: 'white',
                    color: 'black',
                    padding: '10px 15px',
                    borderRadius: '20px',
                    fontWeight: 'bold',
                    marginRight: isMobile ? '0' : '5rem',
                    '&:hover': {
                        backgroundColor: 'white',
                    },
                }}
                onClick={handleSignOut}
            >
                DECONNEXION
            </Button>
        ) : (
            <Link to="/Login" style={{ textDecoration: 'none' }}>
                <Button sx={{
                    backgroundColor: 'white',
                    color: 'black',
                    padding: '10px 30px',
                    borderRadius: '20px',
                    fontWeight: 'bold',
                    marginRight: {md:'3rem',xs:'2rem'},
                    '&:hover': {
                        backgroundColor: 'white',
                    },
                }}>
                    CONNEXION
                </Button>
            </Link>
        )
    );

    const renderAuthButton2 = () => (
        <Typography onClick={handleSignOut}
            sx={{color:'black', fontWeight:'bold', width: '100%'}}>
                DECONNEXION
        </Typography>

    );

    const renderAuthButton3 = () => (
        isAuthenticated() ? (
            <Link to="/Espace_perso" style={{ textDecoration: 'none', width: '100%' }}>
                <Typography sx={{color: 'black', fontWeight: 'bold', width: '100%'}}>
                    PROFIL
                </Typography>
            </Link>
        ) : (
            <Link to="/Login" style={{ textDecoration: 'none', width: '100%' }}>
                <Typography sx={{color: 'black', fontWeight: 'bold', width: '100%'}}>
                    PROFIL
                </Typography>
            </Link>
        )
    );

    const renderMobileLinks = () => (
        <>
            <ListItem button>
                <ListItemIcon>
                    <PersonIcon sx={{color:'black'}}/>
                </ListItemIcon>
                {renderAuthButton3()}
            </ListItem>
            <ListItem 
                button 
                sx={{
                    '&:hover': {
                        backgroundColor: '#f4f4f4',
                    },
                }}
            >
                <ListItemIcon>
                    <InfoIcon sx={{color:'black'}}/>
                </ListItemIcon>
                <ListItemText 
                    primary={
                        <Link to='/Infospratiques' style={{ textDecoration: 'none', color: 'black', width: '100%', fontWeight: 'bold' }}>INFOS PRATIQUES</Link>
                    } 
                />                                
            </ListItem>
            <ListItem 
                button 
                sx={{
                    '&:hover': {
                        backgroundColor: '#f4f4f4',
                    },
                }}
            >
                <ListItemIcon>
                    <PermContactCalendarIcon sx={{color:'black'}} />
                </ListItemIcon>
                <ListItemText 
                    primary={
                        <Link to='/Contact' style={{ textDecoration: 'none', color: 'black', width: '100%', fontWeight: 'bold' }}>CONTACT</Link>
                    } 
                />                                
            </ListItem>
            <ListItem 
                button 
                sx={{
                    '&:hover': {
                        backgroundColor: '#f4f4f4',
                    },
                }}
            >
                <ListItemIcon>
                    <ExitToAppIcon sx={{color:'black'}} />
                </ListItemIcon>
                {renderAuthButton2()}
            </ListItem>
        </>
    );

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: 'transparent',
                position: 'absolute',
                width: '100%',
                marginTop: '1rem',
            }}
        >
            <Box sx={{marginLeft: {md:'3rem',xs:'2rem'},}}>
                <Link to='/' sx={{color:'black', textDecoration: 'none' }}>
                    <img src={`./././logorocs.png`} alt="Logo" style={{width: '10vh', height: 'auto' }} />
                </Link>
            </Box>
            {isMobile ? (
                <>
                    <IconButton
                        edge="start"
                        aria-label="menu"
                        onClick={toggleDrawer(true)}
                        sx={{marginRight:'2rem', color: 'white'}}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
                        <Box
                            sx={{ width: 250, position: 'relative' }}
                            role="presentation"
                            onClick={toggleDrawer(false)}
                            onKeyDown={toggleDrawer(false)}
                        >
                            <List sx={{marginTop:'2rem'}}>
                                {renderMobileLinks()}
                            </List>
                        </Box>
                    </Drawer>
                </>
            ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', flexGrow: 1 }}>
                    {renderLinks()}
                </Box>
            )}
            {!isMobile && <Box>{renderAuthButton()}</Box>}
        </Box>
    );
};

export default Navbar;
